import { styled } from '@mui/material';
import MUIAlert from '@mui/material/Alert';

const Alert = styled(MUIAlert)(() => ({
  paddingTop: 0,
  paddingBottom: 0,
}));
export default Alert;
